import type {
  ForkStatus,
  PausedForkStatus,
  UnpausedForkStatus,
} from "@gearbox-protocol/deploy-tools-shared";
import { createContext, useContext } from "react";

export const ForkStatusContext = createContext<ForkStatus>(null as any);
export const useForkStatus = () => useContext(ForkStatusContext);

export const usePausedForkStatus = () => {
  const status = useForkStatus();
  if (status.paused) {
    return status as PausedForkStatus;
  }
  throw new Error("fork is not paused");
};

export const useUnpausedForkStatus = () => {
  const status = useForkStatus();
  if (!status.paused) {
    return status as UnpausedForkStatus;
  }
  throw new Error("fork is paused");
};
